<template>
  <div :class="['customize-form-radio', withImage && 'customize-form-radio-withimg']">

    <thumbnail v-if="withImage" class="customize-form-radio-thumbnail" :urls="imgUrl" />

    <el-radio :label="label">
      <span><slot></slot></span>
      <span v-if="desc" class="customize-form-radio-desc">{{ desc }}</span>
      <el-input
        v-if="checked && inputable"
        v-model="innerExtraValue"
        :maxlength="500"
        :validate-event="false"
        @blur="onBlur"
      />
    </el-radio>

  </div>
</template>

<script>
import Thumbnail from './thumbnail.vue';
import { isObject, isArray, getFileName } from '../utils';

export default {
  name: 'CustomizeFormRadio',
  components: {
    Thumbnail,
  },
  props: {
    label: [String, Number, Boolean],
    desc: String,         // 描述
    checked: Boolean,
    inputable: Boolean,   // 是否允许输入
    withImage: Boolean,
    url: [Object, Array], // 图片地址对象
    extraValue: String,
  },

  data() {
    return {
      innerExtraValue: '',
    };
  },

  watch: {
    extraValue: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.innerExtraValue = val;
        }
      },
    },

    innerExtraValue(val, prevVal) {
      if (val !== prevVal) {
        this.$emit('inputExtra', val);
      }
    },

    checked(val) {
      if (!val) {
        this.innerExtraValue = '';
      }
    },
  },

  computed: {
    imgUrl() {
      if (!this.withImage) return;
      const url = this.url;

      if (isObject(url)) {
        return [{ ...url, filename: getFileName(url.url) }];
      }

      if (isArray(url)) {
        return url.map((item) => ({ ...item, filename: getFileName(url.url) }));
      }
    },
  },

  methods: {
    onBlur() {
      this.$emit('extraBlur');
    },
  },
};
</script>

<style lang="scss" scoped>
.customize-form-radio {
  display: inline-block;
  margin: 2px 8px;
  padding: 4px 16px;
  transition: background .2s ease-in-out;

  & > label {
    line-height: 1.7;
  }

  &-thumbnail {
    margin: 4px 0;
    height: 150px;
  }

  &-withimg {
    width: 166px;
    margin: 2px 8px 16px 8px;
    padding: 4px 8px;
    border: 1px solid var(--customize-form-border-color);
    border-radius: var(--customize-form-border-radius);
    overflow: hidden;
  }

  ::v-deep {
    .el-radio__label {
      width: 100%;
      word-break: break-all;
      line-height: 1.5;

      span {
        white-space: break-spaces;
        word-break: break-all;
      }
    }
    .el-radio {
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      width: 100%;
      height: 100%;
      padding: 4px 0;

      &__input {
        flex-grow: 0;
        flex-shrink: 0;
        height: 14px;
        margin-top: calc((var(--customize-form-text-font-size) * 1.5 - 14px) / 2);
      }

      &__label {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        flex-shrink: 1;
        white-space: wrap;

        .el-input {
          margin-left: -10px;
        }

        .customize-form-radio-desc {
          line-height: 1.5;
          opacity: 0.7;
          transform: scale(0.85);
          transform-origin: left center;
        }
      }
    }
  }

  &:hover {
    background: #f1f1f1;
  }
}
</style>